import React from "react";

import { Checkbox } from "components/ui/Checkbox";

import styles from "./DataTableHeader.module.css";

export const DataTableHeader = ({
  columns,
  selectable,
  hasRowActions,
  gridColumns,
  isAllSelected,
  isIndeterminate,
  onSelectAll,
  onDeselectAll,
}) => {
  return (
    <div
      className={styles.tableHeader}
      style={{ gridTemplateColumns: gridColumns }}
    >
      {selectable && (
        <div className={styles.checkboxCell}>
          <Checkbox
            checked={isAllSelected}
            ref={(el) => el && (el.indeterminate = isIndeterminate)}
            handleChange={(e) =>
              e.target.checked ? onSelectAll?.() : onDeselectAll?.()
            }
            className={styles.headerCheckbox}
          />
        </div>
      )}
      {columns.map((col) => (
        <div key={col.id} className={styles.headerCell}>
          {col.header}
        </div>
      ))}
      {hasRowActions && <div className={styles.headerCell} />}
    </div>
  );
};
